export default __webpack_public_path__ + "static/media/SndLowerJTurn.54642ba1.mp3";